import React from "react"
import { FormattedMessage } from "react-intl"
import BreadCrumb from "../../BreadCrumb"
import { NamedRoutes } from "../../../../routes"
import PageTitle from "../../PageTitle/PageTitle"
import PromocodeForm from "./PromocodeForm"
import { Grid } from "@material-ui/core"
import { useStyles } from "./Styles"
import { Alert } from "@material-ui/lab"
import { ExternalEntityGroupConsumer, ExternalEntityGroupProvider } from "../../../../ExternalEntityGroupContext"
import { PromocodeConsumer } from "../../../../PromocodeContext"
import { FormLoader } from "../../../Loader/FormLoader"

const PromocodeEditContent = ({ pageTitle, handleNotificationCall }) => {
  const classes = useStyles()
  return (
    <>
      <BreadCrumb links={[
        {
          key: 'BreadcrumbLink-1',
          name: <FormattedMessage id='Sidebar.Links.Promocodes' />,
          link: NamedRoutes.subscription.promocodes.list
        }
      ]} current={pageTitle ?? <FormattedMessage id='Promocodes.List.AddPromocode.Title' />}
      />
      <PageTitle title={pageTitle ?? <FormattedMessage id='Promocodes.List.AddPromocode.Title' />} />
      <PromocodeConsumer>
        {({ isEdit, isLoading, promocodeData, promocodeDataFailure, handleSubmit }) => (
          <Grid container spacing={4}>
            <Grid item xs={12} className={classes.EditProfileContentContainer}>
              <div className={classes.EditProfileContent}>
                {!!isLoading && <FormLoader loading={true} />}
                {!!promocodeDataFailure &&
                  <Alert severity="error"><FormattedMessage id='UpdateProfile.FormErrorAlert' /></Alert>
                }
                <ExternalEntityGroupProvider
                  handleNotificationCall={handleNotificationCall}
                >
                  <ExternalEntityGroupConsumer>
                    {({ externalServiceHandlers }) => (
                      <>
                        {!isLoading && (
                          <PromocodeForm
                            externalServiceHandlers={externalServiceHandlers}
                            promocodeData={(!!isEdit && !!promocodeData && !!Object.keys(promocodeData).length) ? promocodeData : {}}
                            handleNotificationCall={handleNotificationCall}
                            onSubmit={handleSubmit}
                          />
                        )}
                      </>
                    )}
                  </ExternalEntityGroupConsumer>
                </ExternalEntityGroupProvider>
              </div>
            </Grid>
          </Grid>
        )}
      </PromocodeConsumer>
    </>
  )
}
export default PromocodeEditContent